import { FadeUp } from "./Reveal";

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="relative bg-cream px-6 py-28 md:px-12 md:py-36">
      <div className="mx-auto grid max-w-7xl items-center gap-16 md:grid-cols-2">
        <FadeUp>
          <div className="relative">
            <div className="aura-strong absolute -inset-10 rounded-full opacity-50" />
            <div className="relative rotate-[-2deg] border border-ink/15 bg-white/50 p-3 shadow-[0_35px_80px_-30px_rgba(23,18,43,0.45)]">
              <img
                src="/assets/logo-cream.png"
                alt="MarStar Originals compass aura logo"
                loading="lazy"
                className="w-full"
              />
            </div>
          </div>
        </FadeUp>

        <div>
          <FadeUp>
            <p className="font-mono text-[10px] tracking-[0.45em] text-ink/50">02 — ABOUT</p>
          </FadeUp>
          <FadeUp delay={0.08}>
            <h2 className="mt-4 font-script text-6xl leading-[0.95] text-ink md:text-7xl">
              handmade original,
              <br />
              <span className="text-blush">for the sun & beyond.</span>
            </h2>
          </FadeUp>
          <FadeUp delay={0.16}>
            <p className="mt-8 max-w-md text-base leading-relaxed text-ink/65">
              Every MarStar piece is airbrushed, stitched and finished by hand — clothing, bags,
              jewelry and customs carrying the same compass aura. No two stars land the same, and
              neither do two pieces.
            </p>
          </FadeUp>
          <FadeUp delay={0.24}>
            <ul className="mt-10 space-y-3 font-mono text-xs tracking-[0.35em] text-ink/70">
              {["CLOTHING", "BAGS", "JEWELRY", "CUSTOMS"].map((c, i) => (
                <li key={c} className="flex items-center gap-4">
                  <span className="text-blush">0{i + 1}</span>
                  <span className="h-px w-8 bg-ink/25" />
                  {c}
                </li>
              ))}
            </ul>
          </FadeUp>
        </div>
      </div>
    </section>
  );
}
